import axios from '../../../api/axiosSetup3';
import { LprConfigCategory, LprConfigParam } from './types/lpr';

const getCategories = async (): Promise<LprConfigCategory[]> => {
    const { data } = await axios.get<any[]>('/lpr_config_catg', { 
        params: { order: 'ord_num.asc' },
        headers: { 'Content-Type': 'application/json' }, 
    });
    return data;
}

const getParams = async (): Promise<LprConfigParam[]> => {
    const { data } = await axios.get<any[]>('/lpr_config', { 
        params: {
            select: '*,lpr_customer_to_config(value)',
            order: 'ord_num.asc,param_id.asc'
        },
        headers: { 'Content-Type': 'application/json' }, 
    });

    return data.map((raw) => {
        const ctc = Array.isArray(raw.lpr_customer_to_config)
            ? raw.lpr_customer_to_config[0]
            : raw.lpr_customer_to_config;

        const { lpr_customer_to_config, default_value, ...rest } = raw;

        return {
            ...rest,
            value: ctc?.value ?? default_value,
        };
    });    
}

const setParam = async (customer_id: number, param_id: string, value: string): Promise<boolean> => {
    const { status } = await axios.post(
        '/lpr_customer_to_config', 
        {
            customer_id,
            param_id,
            value,
        },
        {
            headers: {
                // UPSERT (ON CONFLICT DO UPDATE)
                'Prefer': 'resolution=merge-duplicates',
            },
        }
    );    
    return status == 200 || status == 201;
}

export const  api = {
  getCategories,
  getParams,
  setParam,
}
